export default __webpack_public_path__ + "static/media/icon_community.a5934595.svg";